import { CreateSaleDTO, SaleDTO, UpdateSaleDTO } from 'src/dto/sale'
import { SaleService } from 'src/services/api/sale.service'

export class SaleController {
  private service: SaleService

  constructor() {
    this.service = new SaleService()
  }

  public async getSaleList(farmId: string): Promise<SaleDTO[]> {
    const response = await this.service.getSaleList(farmId)
    return response.data
  }

  public async createSale(farmId: string, createNewSaleDto: CreateSaleDTO): Promise<SaleDTO> {
    const response = await this.service.createSale(farmId, createNewSaleDto)
    return response.data
  }

  public async updateSale(farmId: string, updateSaleDto: UpdateSaleDTO): Promise<SaleDTO> {
    const response = await this.service.updateSale(farmId, updateSaleDto)
    return response.data
  }
}
